import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import moment from 'moment';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import UndoOutlinedIcon from '@mui/icons-material/UndoOutlined';
import CustomButton from '../../../../components/buttonComponent/CustomButton';
import { baseColors } from '../../../../Themes/colors';
import { designPx } from './aiReviewScale';
import { REVIEW_COLORS } from './OverviewSourceDocuments';
export var ACCEPT_REVIEW_NEXT_STATUS = '59 - Docs in SS Review';
export var DOCS_BACK_MISSING_INFO_STATUS = '56 - Docs Back Missing Info';
var OverviewReviewHeader = function (_a) {
    var onRerun = _a.onRerun, onAcceptReview = _a.onAcceptReview, onDocsBackMissingInfo = _a.onDocsBackMissingInfo, hasResults = _a.hasResults, canDecide = _a.canDecide, _b = _a.isRerunning, isRerunning = _b === void 0 ? false : _b, _c = _a.title, title = _c === void 0 ? 'Post-Docs AI Review' : _c, _d = _a.description, description = _d === void 0 ? 'Runs when the signed documents are received from the customer' : _d, lastRunAt = _a.lastRunAt, _e = _a.showActions, showActions = _e === void 0 ? true : _e;
    var lastRun = lastRunAt ? moment(lastRunAt) : null;
    return (React.createElement(Box, { sx: {
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            justifyContent: 'space-between',
            columnGap: designPx(16),
            rowGap: designPx(10),
            px: designPx(12),
            py: designPx(8),
            backgroundColor: REVIEW_COLORS.white,
            border: "1px solid ".concat(REVIEW_COLORS.gray200),
            borderRadius: designPx(12),
        } },
        React.createElement(Stack, { direction: "row", alignItems: "center", sx: { gap: designPx(12), minWidth: 0 } },
            React.createElement(Box, { sx: {
                    width: designPx(34),
                    height: designPx(34),
                    borderRadius: designPx(12),
                    flexShrink: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: baseColors.bluePreset[10],
                    color: baseColors.fullWhite,
                    '& svg': { fontSize: designPx(20), color: 'inherit' },
                } },
                React.createElement(AutoAwesomeIcon, null)),
            React.createElement(Box, { sx: { minWidth: 0 } },
                React.createElement(Typography, { sx: { fontSize: designPx(14), lineHeight: designPx(20), fontWeight: 700, color: REVIEW_COLORS.gray800 } }, title),
                React.createElement(Typography, { sx: { fontSize: designPx(11), lineHeight: designPx(16), color: REVIEW_COLORS.gray500 } }, description),
                (lastRun === null || lastRun === void 0 ? void 0 : lastRun.isValid()) && (React.createElement(Stack, { direction: "row", alignItems: "center", sx: { gap: designPx(4), mt: designPx(2), color: REVIEW_COLORS.gray500 } },
                    React.createElement(AccessTimeIcon, { sx: { fontSize: designPx(13), color: 'inherit' } }),
                    React.createElement(Typography, { sx: { fontSize: designPx(11), lineHeight: designPx(16), color: 'inherit' } },
                        "Last run ",
                        lastRun.format('MMM DD, YYYY · hh:mm A')))))),
        showActions && React.createElement(Stack, { direction: "row", alignItems: "center", flexWrap: "wrap", sx: { gap: designPx(8) } },
            React.createElement(CustomButton, { variant: "outlined", fullWidth: false, startIcon: React.createElement(RefreshOutlinedIcon, { sx: { fontSize: 16 } }), onClick: onRerun, disabled: isRerunning, borderColor: baseColors.greyPreset[40], textColor: baseColors.darkPreset[10], bgColor: baseColors.fullWhite, SMButton: true }, "Re-run"),
            hasResults && canDecide && (React.createElement(React.Fragment, null,
                React.createElement(CustomButton, { variant: "contained", fullWidth: false, startIcon: React.createElement(DoneAllIcon, { sx: { fontSize: 16 } }), onClick: onAcceptReview, SMButton: true }, "Accept AI Review"),
                React.createElement(CustomButton, { variant: "outlined", fullWidth: false, startIcon: React.createElement(UndoOutlinedIcon, { sx: { fontSize: 16 } }), onClick: onDocsBackMissingInfo, borderColor: REVIEW_COLORS.amber200, textColor: REVIEW_COLORS.amber700, bgColor: REVIEW_COLORS.amber50, SMButton: true }, DOCS_BACK_MISSING_INFO_STATUS))))));
};
export default OverviewReviewHeader;
